<template>
  <form @submit.prevent="submit" class="comment-form" v-if="authenticated">
    <div class="comment-list__avatar">
      <img :src="avatar" />
    </div>
    <textarea
      class="comment-form__input"
      v-model.trim="commentText"
      :placeholder="placeholder"
      spellcheck="true"
      :maxlength="commentMaxLength"
    ></textarea>
    <button class="btn btnRed comment-form__button" :disabled="submitting">
      {{ label }}
    </button>
  </form>
</template>

<script>
export default {
  name: "CommentForm",
  props: {
    reply: Boolean,
    placeholder: { type: String, default: "My comment..." }
  },
  data: function() {
    return {
      commentText: "",
      commentMaxLength: Grabcad.AttributeLimits.Generic.CONTENT_BODY,
      avatar: Grabcad.memberAvatar,
      authenticated: Grabcad.authenticated,
      submitting: false
    };
  },
  computed: {
    label: function() {
      return this.reply ? "Reply" : "Comment";
    }
  },
  methods: {
    submit: function() {
      if (this.commentText) {
        this.submitting = true;
        this.$emit("handleSubmit", this.commentText);
      } else {
        this.$refs.text.focus();
      }
    },
    resetSubmitting() {
      this.submitting = false;
    },
    resetForm() {
      this.commentText = "";
      this.submitting = false;
    }
  }
};
</script>
